import React from 'react';
import { Smartphone } from 'lucide-react';

/**
 * Reusable component to display mobile restriction message in popups
 * @param {Object} props
 * @param {string} props.title - Custom title (default: "Content Not Available")
 * @param {string} props.message - Custom message (default: standard message)
 * @param {string} props.className - Additional CSS classes
 */
export function MobileRestrictionMessage({ 
    title = "Content Not Available",
    message = "Content not available for mobile screen. Please use a desktop or tablet device.",
    className = ""
}) {
    return (
        <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
            <Smartphone className="h-16 w-16 text-muted-foreground mb-4" />
            <h3 className="text-lg font-semibold text-foreground mb-2">
                {title}
            </h3>
            <p className="text-sm text-muted-foreground">
                {message}
            </p>
        </div>
    );
}
